import HttpClientAdapter from '@/shared/services/httpClientAdapter';
import { Permission } from '@/modules/user/entities/permission';

class PermissionService extends HttpClientAdapter {
  constructor() {
    super('AUTH');
  }

  getPermissions<T = Permission[]>() {
    return this.get<T>('/permissions');
  }
}

export default PermissionService;
